import WalkthroughTabs from './WalkthroughTabs';

export default WalkthroughTabs;
